export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ11.c566180d.mp3";